import { render } from "./SuperAdminInvoicesTable.vue?vue&type=template&id=ea966e18"
import script from "./SuperAdminInvoicesTable.vue?vue&type=script&lang=js"
export * from "./SuperAdminInvoicesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__